// extracted by mini-css-extract-plugin
module.exports = {"disableBlockWrapper":"BlurBackgroundBlock_disableBlockWrapper__bXamA","disableBlockContent":"BlurBackgroundBlock_disableBlockContent__1q8Om"};